module.exports = __webpack_public_path__ + "img/planFamiliarMobile.0c77ca63.svg";